import React from 'react';

import {
  CheckoutLayoutBlock,
  PaymentBlockCardIcons,
  SweetpassCheckoutCardPicker,
} from '@order/components';
import type { SubscriptionCreditCard } from '@order/graphql';

export const SweetpassCheckoutCardBlock = (
  props: SweetpassCheckoutCardBlockProps,
) => {
  return (
    <CheckoutLayoutBlock>
      <PaymentBlockCardIcons />
      <SweetpassCheckoutCardPicker {...props} />
    </CheckoutLayoutBlock>
  );
};

// ─── Types ─────────────────────────────────────────────────────────────

type SweetpassCheckoutCardBlockProps = Readonly<{
  selectedCreditCard?: Partial<SubscriptionCreditCard>;
  creditCards: ReadonlyArray<Partial<SubscriptionCreditCard>>;
  handleAddCreditCard: () => void;
  handleSelectCreditCard: (creditCard: Partial<SubscriptionCreditCard>) => void;
}>;
